import addClassRoomTemplate from './../add-class-room/add-class-room.html';
import template from './step-1.html';

class StepFirstComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $q, $state,
    SchoolCommonRoomService,
    ClassRoomService,
    EmployeeService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$q = $q;
    this.$state = $state;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.ClassRoomService = ClassRoomService;
    this.EmployeeService = EmployeeService;

    this.mySchoolCommonRoom = {};
    this.selectedClassRoom = {};
    this.selectedEmployees = [];
  }

  $onInit() {
    this.mySchoolCommonRoom = this.SchoolCommonRoomService.getMySchoolCommonRoom();
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.schoolCommonRoom) {
      this.schoolCommonRoom = {...this.schoolCommonRoom};
    }

    if (changes.unassignedClassRooms) {
      this.unassignedClassRooms = Object.assign([], this.unassignedClassRooms);
    }

    if (changes.unassignedEmployees) {
      this.unassignedEmployees = Object.assign([], this.unassignedEmployees);
    }

    if (changes.roles) {
      this.roles = Object.assign([], this.roles);
    }
  }

  assignClassRoom() {
    this.ClassRoomService
      .assignClassRoom(this.selectedClassRoom)
      .then(() => {
        this.selectedClassRoom = {};
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Dodano salę do świetlicy')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(errorMessage => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent(errorMessage)
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  addClassRoom(ev) {
    this.ClassRoomService.getUnassignedClassRooms().then(result => {
      this.unassignedClassRooms = result;
      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'AddClassRoomController',
        template: addClassRoomTemplate,
        clickOutsideToClose: true,
        locals: {classRooms: this.unassignedClassRooms},
        targetEvent: ev
      })
        .then(() => {
          this.ClassRoomService.getUnassignedClassRooms().then(result => {
            this.unassignedClassRooms = result;
          });
        }, () => {});
    });
  }

  removeClassRoom(assignedClassRooms) {
    this.ClassRoomService.deleteClassRoom(assignedClassRooms)
      .then(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Usunięto salę ze świetlicy')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  next(ev) {
    if (this.assignedClassRooms.length === 0) {
      this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Brak przypisanej sali')
          .textContent('Przypisz co najmniej jedną salę do świetlicy.')
          .ariaLabel('Przypisz co najmniej jedną salę do świetlicy')
          .ok('Zamknij')
          .targetEvent(ev)
      );
    } else {
      this.$state.go('modules.settings.step2');
    }
  }
}

export const StepFirst = {
  bindings: {
    assignedClassRooms: '<',
    employees: '<',
    me: '<',
    schoolCommonRoom: '<',
    unassignedClassRooms: '<',
    unassignedEmployees: '<',
    roles: '<'
  },
  template,
  controller: StepFirstComponent
};
